import { useState, useEffect } from 'react'
import { clearScans, resetNotesListAndNoteById } from '../../../../redux/flows/portal/lobby'
import { useAppDispatch, useAppSelector } from '../../../../redux/store'

export const usePatientReport = () => {
  const dispatch = useAppDispatch()
  const patientDetails = useAppSelector((state) => state.lobbyPortal.patientDetails)
  const [rightTab, setRightTab] = useState<'info' | 'scans' | 'notes' | 'traffic'>('info')

  // Set default tab based on isFirstBooking
  // useEffect(() => {
  //   if (patientDetails?.currentVisit) {
  //     const defaultTab = patientDetails.currentVisit.isFirstBooking === false ? 'traffic' : 'info'
  //     setRightTab(defaultTab)
  //   }
  // }, [patientDetails?.currentVisit?.isFirstBooking])

  useEffect(() => {
    return () => {
      dispatch(clearScans())
      dispatch(resetNotesListAndNoteById())
    }
  }, [dispatch])

  return {
    currentPatient: patientDetails,
    rightTab,
    setRightTab,
  }
}
